import { NextPage } from 'next'
import { explorePageInitialProps, PagePropsWrapper } from 'lib/routing/nextPageUtils'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { ProductConstraint } from 'services/ContentfulService/constraints'
import { LoansPreviewPage } from 'experiences/explore/simpleExplorePages/LoansPreviewPage'
import { ExplorePageProps } from 'types/page'
import { ContentfulProducts, ROUTES } from 'parameters/index'

const ExploreLoansPage: NextPage<PagePropsWrapper<ExplorePageProps>> = ({ metaTags, pageProps: { articles } }) => (
	<StandardLayout metaTags={metaTags}>
		<LoansPreviewPage articles={articles} />
	</StandardLayout>
)

ExploreLoansPage.getInitialProps = explorePageInitialProps(
	ROUTES.NATIVE_LOANS,
	ProductConstraint(ContentfulProducts.Loans)
)

export default ExploreLoansPage
